// eslint-disable-next-line jira/import-whitelist
import { createAri } from '@jira/platform__utils-ari/src/index.tsx';
import { JiraWorkspaceAri } from '@atlassian/ari/jira';
import { fg } from '@atlassian/jira-feature-gating';

const CAPABILITIES_QUERY_OLD = `
	query avpPermissions_getCapabilities($cloudId: ID!) {
		avpPermissions_getCapabilities(
			input: {
				cloudId: $cloudId
				capabilityRequests: [
					{ capabilityId: "JsmMetrics" }
					{ capabilityId: "JiraMetrics" }
					{ capabilityId: "JiraMetricsAdvanced" }
					{ capabilityId: "JiraMetricsAdvanced2" }
					{ capabilityId: "MercuryMetrics" }
					{ capabilityId: "ChartUpdatedAtHistoryLength" }
				]
			}
		) @optIn(to: "AVPPermissions") {
			capabilities {
				capabilityId
				result {
					failureCode
					failureType
					hasAccess
					hasManage
					hasWrite
					productResults {
						productId
						result {
							failureCode
							failureType
							hasAccess
							hasManage
							hasWrite
							properties {
								key
								value {
									... on AVPPermissionsPropertyValueList {
										__typename
										values
									}
									... on AVPPermissionsPropertyValueString {
										value
									}
								}
							}
							reason
						}
					}
					properties {
						key
						value {
							... on AVPPermissionsPropertyValueList {
								__typename
								values
							}
							... on AVPPermissionsPropertyValueString {
								value
							}
						}
					}
					reason
				}
			}
		}
	}
`;

const CAPABILITIES_QUERY = `
	query avpPermissions_getCapabilities($cloudId: ID!, $workspaceAri: ID) {
		avpPermissions_getCapabilities(
			input: {
				cloudId: $cloudId
				workspaceAri: $workspaceAri
				capabilityRequests: [
					{ capabilityId: "JsmMetrics" }
					{ capabilityId: "JiraMetrics" }
					{ capabilityId: "JiraMetricsAdvanced" }
					{ capabilityId: "JiraMetricsAdvanced2" }
					{ capabilityId: "MercuryMetrics" }
					{ capabilityId: "ChartUpdatedAtHistoryLength" }
				]
			}
		) @optIn(to: "AVPPermissions") {
			capabilities {
				capabilityId
				result {
					failureCode
					failureType
					hasAccess
					hasManage
					hasWrite
					productResults {
						productId
						result {
							failureCode
							failureType
							hasAccess
							hasManage
							hasWrite
							properties {
								key
								value {
									... on AVPPermissionsPropertyValueList {
										__typename
										values
									}
									... on AVPPermissionsPropertyValueString {
										value
									}
								}
							}
							reason
						}
					}
					properties {
						key
						value {
							... on AVPPermissionsPropertyValueList {
								__typename
								values
							}
							... on AVPPermissionsPropertyValueString {
								value
							}
						}
					}
					reason
				}
			}
		}
	}
`;

export async function fetchAvpPermissionsGetCapabilities(
	activationId: string,
	cloudId: string,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any> {
	const response = await fetch('/gateway/api/graphql', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'atl-attribution': JSON.stringify({
				atlWorkspaceId: activationId,
				tenantId: cloudId,
				businessUnit: 'Engineering-AVP',
				service: 'avp-chartio-castle',
				costCenter: '3408',
			}),
			'X-Query-Context': createAri({
				resourceOwner: 'platform',
				resourceType: 'site',
				resourceId: cloudId,
			}),
		},
		credentials: 'include',
		body: fg('platform_avp_capabilities_workspaceari')
			? JSON.stringify({
					operationName: 'avpPermissions_getCapabilities',
					query: CAPABILITIES_QUERY,
					variables: {
						cloudId,
						workspaceAri: JiraWorkspaceAri.create({
							siteId: cloudId,
							activationId,
						}).toString(),
					},
				})
			: JSON.stringify({
					operationName: 'avpPermissions_getCapabilities',
					query: CAPABILITIES_QUERY_OLD,
					variables: { cloudId },
				}),
	});

	const json = await response.json();
	return json?.data?.avpPermissions_getCapabilities ?? { capabilities: [] };
}
